module.exports = __webpack_public_path__ + "2375fc9d673aac62919a041b83d9b673.png";